import { render, staticRenderFns } from "./NavbarAfterLogin-v3.vue?vue&type=template&id=fe8588bc&scoped=true&lang=pug"
import script from "./NavbarAfterLogin-v3.vue?vue&type=script&lang=js"
export * from "./NavbarAfterLogin-v3.vue?vue&type=script&lang=js"
import style0 from "./NavbarAfterLogin-v3.vue?vue&type=style&index=0&id=fe8588bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8588bc",
  null
  
)

export default component.exports